import styled from "styled-components";

const Wrapper = styled.div`
    padding: 56px 112px;
    border-top: 1px solid #e0e0e0;
    background: #fff;

    .additionalTitle {
        font-family: McKinsey Sans;
        font-size: 28px;
        font-weight:  500;
        line-height: 32px;
        margin-bottom: 16px;
    }

    .linksRow {
        display: flex;
        flex-direction: row;
        gap: 24px;
        flex-wrap: wrap;
    }

    a {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 0;
        color: #000;
        text-decoration: none;
        &:hover {
            color: #2251ff;
            text-decoration: underline;
        }
        img {
            height: 16px;
        }
    }
`

export default Wrapper